export const DEFAULT_UI_DENSITY = 100;
export const MAX_UI_DENSITY = 200;

export function normalizeUiDensity(value: number): number {
  return Number.isFinite(value)
    ? Math.round(Math.min(MAX_UI_DENSITY, Math.max(0, value)))
    : DEFAULT_UI_DENSITY;
}

export interface UiDensityPreference {
  read(): number;
  write(density: number): boolean;
}
